import { useState, useEffect, useContext } from "react";
import { MultiSelect } from "../../../components/menu/multiSelect";
import { AuthContext } from "../../../contexts/AuthContext";
import { useAuthFetch } from "../../../hooks/useAuthFetch";

function ReportingUserFilter({
  selected,
  onUpdate,
  onClear,
  fullWidth = false,
  labelPosition = "inset",
}) {
  const [usersOptions, setUsersOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { authContext } = useContext(AuthContext);
  const orgId = authContext.organization.orgId;
  const authFetch = useAuthFetch();

  const fetchUsers = async () => {
    if (!orgId) return;

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/v1/users?org_id=${orgId}`
      );

      if (response.ok) {
        const data = await response.json();

        const augmentedData = data.users.map((user) => ({
          ...user,
          name: user.first_name + " " + user.last_name,
        }));

        setUsersOptions(augmentedData);
        setIsLoading(false);
      } else {
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [orgId]);

  return (
    <MultiSelect
      label="Users"
      options={usersOptions}
      onUpdate={onUpdate}
      onClear={onClear}
      selected={selected}
      isLoading={isLoading}
      fullWidth={fullWidth}
      labelPosition={labelPosition}
    />
  );
}

export { ReportingUserFilter };
